import { createRoute } from '@tanstack/react-router';
import { layoutRoute } from '@/router/root-routes.tsx';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { MailIcon, PhoneIcon } from 'lucide-react';

export const contactRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/contact',
  component: ContactPage,
});

type TLocation = {
  name: string;
  email: string;
  phone?: string;
  contact?: string;
  address?: string[];
};

const locations: TLocation[] = [
  {
    name: 'New York',
    phone: '212.226.4344',
    email: 'info@saccocarpet.com',
    address: ['30 East 33rd Street', 'Floor 10', 'New York, New York 10016'],
  },
  {
    name: 'London',
    phone: '020.8191.8888',
    email: 'london@saccocarpet.com',
    address: ['Design Centre East', 'Unit 314, 3rd Floor, Lots Road', 'Chelsea Harbour', 'London, SW10 OXF'],
  },
  {
    name: 'Chicago',
    contact: 'Dani Sacco',
    email: 'dani@saccocarpet.com',
  },
  {
    name: 'Los Angeles',
    contact: 'Dani Sacco',
    email: 'dani@saccocarpet.com',
  },
];

function ContactPage() {
  return (
    <div>
      <div
        className="min-h-64 lg:min-h-96 xl:min-h-120"
        style={{
          backgroundImage: `url(/media/contact.jpeg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }}
      ></div>
      <div className="max-w-6xl mx-auto">
        <AppBreadcrumbs items={[{ text: 'Home', href: '/' }, { text: 'Contact' }]} />
        <h1 className="uppercase text-center font-medium mb-8">Contact Us</h1>
        <div className="grid sm:grid-cols-2 xl:grid-cols-4">
          {locations.map((location) => (
            <div key={location.name}>
              <h2 className="font-medium text-3xl">{location.name}</h2>
              {location.contact && (
                <div className="flex items-center gap-2">
                  {location.contact}
                </div>
              )}
              {location.phone && (
                <div className="flex items-center gap-2">
                  <PhoneIcon size={15} />
                  {location.phone}
                </div>
              )}
              <div className="flex items-center gap-2">
                <MailIcon size={15} />
                {location.email}
              </div>
              <div className="mt-2">
                {location.address?.map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
